var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocument = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5625,
    y: 4.6875,
    width: 21.875,
    height: 16.4062,
    fill: "#B9D5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.34375,
    y: 1.5625,
    width: 7.8125,
    height: 16.4062,
    fill: "#B9D5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 0C3.01607 0 2.08333 0.93274 2.08333 2.08333V3.125C2.08333 3.18403 2.08579 3.24248 2.0906 3.30026C0.873064 3.7272 0 4.88664 0 6.25V18.75C0 20.4759 1.39911 21.875 3.125 21.875H21.875C23.6009 21.875 25 20.4759 25 18.75V6.25C25 4.52411 23.6009 3.125 21.875 3.125H12.3687C11.9062 1.32789 10.2748 0 8.33333 0H4.16667ZM10.138 3.125C9.77774 2.50229 9.10446 2.08333 8.33333 2.08333H4.16667V3.125H10.138ZM3.125 5.20833C2.5497 5.20833 2.08333 5.6747 2.08333 6.25V18.75C2.08333 19.3253 2.5497 19.7917 3.125 19.7917H21.875C22.4503 19.7917 22.9167 19.3253 22.9167 18.75V6.25C22.9167 5.6747 22.4503 5.20833 21.875 5.20833H3.125Z",
    fill: "#B9D5F7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/document.8881f1048dfcdd91351eba14b3d1224c.svg";